import { CLASS_NAMES } from '@bs/constants';

/**
 * A class for the Swiper module
 */
export default class FeaturedJobsCarousel {
  /**
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    this.element = element;
    this.init();
  }

  /**
   * Initialize module
   * @returns {object} FeaturedJobsCarousel
   * @chainable
   */
  init() {
    this.cacheDomReferences().setupHandlers().enable();

    return this;
  }

  /**
   * Cache DOM references
   * @returns {object} FeaturedJobsCarousel
   * @chainable
   */
  cacheDomReferences() {
    this.swiperContainer = this.element.querySelector(`.${CLASS_NAMES.SWIPER}`);

    return this;
  }

  /**
   * Bind handlers
   * @returns {object} FeaturedJobsCarousel
   * @chainable
   */
  setupHandlers() {
    this.initSwiperHandler = this.initSwiper.bind(this);
    return this;
  }

  /**
   * Enable module
   * @returns {object} FeaturedJobsCarousel
   * @chainable
   */
  enable() {
    if (this.swiperContainer && window.Swiper) {
      this.initSwiperHandler();
    }
    return this;
  }

  /**
   * Initialize Swiper (CDN version)
   * @returns {object} FeaturedJobsCarousel
   */
  initSwiper() {
    this.swiper = new window.Swiper(this.swiperContainer, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      loop: true,

      navigation: {
        nextEl: `.${CLASS_NAMES.SWIPER_BTN}.${CLASS_NAMES.NEXT}`,
        prevEl: `.${CLASS_NAMES.SWIPER_BTN}.${CLASS_NAMES.PREV}`
      },

      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 2.15,
          spaceBetween: 30
        }
      }
    });

    return this;
  }
}
